import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Step from './screens/step'
import Voice from './screens/voice/voice'
import Demo from './screens/demo'

import React from 'react'
import { AvatarProvider } from './screens/avatar/avatar.context'

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<AvatarProvider />}>
          <Route path='/' element={<Step />} />
          <Route path='/demo' element={<Demo />} />
        </Route>
        <Route path='/voice' element={<Voice />} />
      </Routes>
    </Router>
  )
}

export default App
